import type { IconProps } from '@radix-ui/react-icons/dist/types';
import * as React from 'react';

export const ConnectionsIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 5.5C10.1716 5.5 9.5 6.17158 9.5 7C9.5 7.82843 10.1716 8.5 11 8.5C11.8284 8.5 12.5 7.82843 12.5 7C12.5 6.17158 11.8284 5.5 11 5.5ZM11 4.50003C10.0395 4.50003 9.20555 5.04165 8.78687 5.83615L5.39575 3.71673C5.46357 3.48963 5.5 3.24913 5.5 3.00003C5.5 1.61933 4.3807 0.50003 3 0.50003C1.6193 0.500029 0.500001 1.61933 0.500001 3.00003C0.500001 4.2095 1.35889 5.21836 2.5 5.44999L2.5 8.55001C1.35889 8.78165 0.5 9.79052 0.5 11C0.5 12.3807 1.6193 13.5 3 13.5C4.3807 13.5 5.5 12.3807 5.5 11C5.5 10.7509 5.46357 10.5103 5.39576 10.2833L8.78687 8.16387C9.20555 8.95836 10.0395 9.5 11 9.5C12.3807 9.5 13.5 8.38072 13.5 7C13.5 5.61929 12.3807 4.50003 11 4.50003ZM2.99033 9.50003L3.00967 9.50003C3.83362 9.50523 4.5 10.1748 4.5 11C4.5 11.8284 3.8284 12.5 3 12.5C2.1716 12.5 1.5 11.8284 1.5 11C1.5 10.1748 2.16638 9.50523 2.99033 9.50003ZM3.5 8.55001L3.5 5.44999C4.10125 5.32794 4.62414 4.99012 4.98433 4.52088L8.5147 6.72736C8.50498 6.81691 8.5 6.90787 8.5 7C8.5 7.09214 8.50498 7.18311 8.5147 7.27265L4.98434 9.47913C4.62414 9.00988 4.10125 8.67205 3.5 8.55001ZM3 4.50003C3.8284 4.50003 4.5 3.82843 4.5 3.00003C4.5 2.17153 3.8284 1.50003 3 1.50003C2.1716 1.50003 1.5 2.17153 1.5 3.00003C1.5 3.82843 2.1716 4.50003 3 4.50003Z"
          fill={color}
        />
      </svg>
    );
  }
);

export const SharedWithMeIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.5 5.00006C3.22386 5.00006 3 5.22392 3 5.50006V11.5001C3 11.7762 3.22386 12.0001 3.5 12.0001H11.5C11.7761 12.0001 12 11.7762 12 11.5001V5.50006C12 5.22392 11.7761 5.00006 11.5 5.00006H10.25C9.97386 5.00006 9.75 4.7762 9.75 4.50006C9.75 4.22392 9.97386 4.00006 10.25 4.00006H11.5C12.3284 4.00006 13 4.67163 13 5.50006V11.5001C13 12.3285 12.3284 13.0001 11.5 13.0001H3.5C2.67157 13.0001 2 12.3285 2 11.5001V5.50006C2 4.67163 2.67157 4.00006 3.5 4.00006H4.75C5.02614 4.00006 5.25 4.22392 5.25 4.50006C5.25 4.7762 5.02614 5.00006 4.75 5.00006H3.5Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.99998 8.4136L9.43178 6.9818C9.60752 6.80607 9.89244 6.80607 10.0682 6.9818C10.2439 7.15754 10.2439 7.44246 10.0682 7.6182L7.81818 9.8682C7.73379 9.95259 7.61933 10 7.49998 10C7.38063 10 7.26617 9.95259 7.18178 9.8682L4.93178 7.6182C4.75608 7.44246 4.75608 7.15754 4.93178 6.9818C5.10752 6.80607 5.39244 6.80607 5.56818 6.9818L6.99998 8.4136L6.99998 1.55C6.99998 1.27386 7.22384 1.05 7.49998 1.05C7.77612 1.05 7.99998 1.27386 7.99998 1.55L7.99998 8.4136Z"
          fill={color}
        />
      </svg>
    );
  }
);

export const PrivateFileIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.5 2C3.22386 2 3 2.22386 3 2.5V12.5C3 12.7761 3.22386 13 3.5 13H6V14H3.5C2.67157 14 2 13.3284 2 12.5V2.5C2 1.67157 2.67157 1 3.5 1H8.5C8.63261 1 8.75979 1.05268 8.85355 1.14645L12.8536 5.14645C12.9473 5.24021 13 5.36739 13 5.5V6H12H11H8.5C8.22386 6 8 5.77614 8 5.5V2H3.5ZM11.2929 5L9 2.70711V5H11.2929Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 10.0867C10 9.66363 10.1059 9.40596 10.2431 9.25695C10.3739 9.1149 10.5992 9 11.0007 9C11.4012 9 11.6263 9.1148 11.7571 9.25683C11.8942 9.4058 12 9.66323 12 10.0853V10.5H10V10.0867ZM9 10.5V10.0867C9 9.50949 9.14438 8.97382 9.50746 8.57954C9.87695 8.17832 10.402 8 11.0007 8C11.599 8 12.1235 8.17851 12.4927 8.57946C12.8555 8.97346 13 9.50868 13 10.0853V10.5C13.5523 10.5 14 10.9477 14 11.5V14C14 14.5523 13.5523 15 13 15H9C8.44772 15 8 14.5523 8 14V11.5C8 10.9477 8.44771 10.5 9 10.5ZM9 11.5H13V14H9V11.5Z"
          fill={color}
        />
      </svg>
    );
  }
);

export const NewFileIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 2.5C3 2.22386 3.22386 2 3.5 2H8V5.5C8 5.77614 8.22386 6 8.5 6H12V7H13V5.5C13 5.36739 12.9473 5.24021 12.8536 5.14645L8.85355 1.14645C8.75979 1.05268 8.63261 1 8.5 1H3.5C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H7V13H3.5C3.22386 13 3 12.7761 3 12.5V2.5ZM11.2929 5L9 2.70711V5H11.2929Z"
          fill={color}
        />
        <path d="M9.25 11.5H13.75" stroke={color} strokeLinecap="round" />
        <path d="M11.5 13.75V9.25" stroke={color} strokeLinecap="round" />
      </svg>
    );
  }
);
